import { useTextMessage, useTextMessages } from "queries/texts"
import useWhatsAppTemplate from "services/useWhatsAppTemplate"
import { isWhatsappTextMessageConfigured } from "utilities/whatsappTemplates"

// Resolve the event's default opt-in TextMessage (with its WhatsApp template)
// by numeric `defaultOptInTextId`. The texts list provides the numeric-id →
// externalId mapping so useTextMessage stays keyed on `externalId` like every
// other consumer.
//
// `isConfigured` is true iff the resolved TextMessage's content variables are
// all filled. The caller uses this to decide whether the auto-opt-in flow can
// actually fire — a default opt-in with missing variables would fail at the
// BE auto-dispatch step.
const useDefaultOptInText = (
  eventId: string,
  defaultOptInTextId: number | null | undefined,
  enabled: boolean,
) => {
  const { data: textsResponse } = useTextMessages(eventId)
  const lookupId = enabled && defaultOptInTextId
    ? (textsResponse?.data ?? []).find((t) => t.id === defaultOptInTextId)?.externalId
    : undefined
  const { data: optInText } = useTextMessage(eventId, lookupId)
  const { template: optInTemplate } = useWhatsAppTemplate(
    optInText?.whatsappContentSid,
  )
  const isConfigured = isWhatsappTextMessageConfigured(optInText, optInTemplate)

  return { optInText, optInTemplate, isConfigured }
}

export default useDefaultOptInText
